import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import IconPeopleBlack from "../../../assets/iconPeopleBlack";
import IconBagsBlack from "../../../assets/iconBagsBlack";
const CarInclusionsShort = ({ myData }) => {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.target instanceof Element) {
                    const slideElement = document.querySelector('[data-index="0"]');
                    if (slideElement) {
                        const isActive = slideElement.classList.contains('slick-active') &&
                            slideElement.classList.contains('slick-current');
                        setIsVisible(isActive);
                    }
                }
            });
        });
        const sliderElement = document.querySelector('[data-index="0"]');
        if (sliderElement) {
            observer.observe(sliderElement, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
        return () => {
            observer.disconnect();
        };
    }, []);
    return (_jsxs("div", { className: `detail__features detail__features--spacexs ${!isVisible ? "hidden" : ''}`, children: [_jsxs("div", { className: "feature-item", children: [_jsx("div", { className: "feature-icon", children: _jsx(IconPeopleBlack, {}) }), _jsx("div", { className: "feature-text", children: myData.car.specifications.totalPassengers })] }), _jsxs("div", { className: "feature-item", children: [_jsx("div", { className: "feature-icon", children: _jsx(IconBagsBlack, {}) }), _jsx("div", { className: "feature-text", children: myData.car.specifications.totalBaggages })] })] }));
};
export default CarInclusionsShort;
